import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardComponent } from '../ui/card/card.component/card.component';
import { CardContentComponent } from '../ui/card/card-content.component/card-content.component';




@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    CardContentComponent
  ],
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent {}
